import { BRAND_HOOK_SHORT } from './brandAboutCopy';
import { SITE_ORIGIN } from './siteConfig';

export const META_HOME = {
  title: 'WebCodeCraft | UK Web Design | £0 Upfront | 5-Star Rated',
  description:
    'Need a professional website? Get a custom build + hosting + maintenance for just £19.99/mo. Optimised PageSpeed & SEO-ready. No massive upfront fees. Join our 5-star local network today! WebCodeCraft — Devon & UK.',
  canonical: `${SITE_ORIGIN}/`
};

export const META_SERVICES = {
  title: 'Pay monthly web design — hosting, SSL & security | WebCodeCraft Devon',
  description:
    'Stop paying thousands for a website. WebCodeCraft offers managed pay-monthly web design including hosting, SSL, and security. Perfect for Devon startups wanting a professional site with zero stress.',
  canonical: `${SITE_ORIGIN}/services`
};

export const META_LOCATIONS_HUB = {
  title: 'Areas We Serve | Web Design | £0 Upfront | 5-Star Rated | WebCodeCraft',
  description:
    'Need a professional site? Custom build + hosting + maintenance from £19.99/mo across Devon, Cornwall & UK cities. Optimised PageSpeed & SEO-ready. No massive upfront fees. Join our 5-star local network today!',
  canonical: `${SITE_ORIGIN}/locations`
};

export const META_ECOMMERCE = {
  title: 'E-commerce & custom web apps | WebCodeCraft',
  description:
    'Scale your business with bespoke e-commerce solutions and custom web apps. From secure checkouts to AI route optimization, WebCodeCraft builds high-performance tools tailored to your needs.',
  canonical: `${SITE_ORIGIN}/ecommerce-web-apps`
};

export const META_FAQ = {
  title: 'FAQ | WebCodeCraft — pay monthly websites',
  description: BRAND_HOOK_SHORT,
  canonical: `${SITE_ORIGIN}/faq`
};

export const META_TRADES_HUB = {
  title: 'Web design for tradespeople & builders by city | WebCodeCraft',
  description:
    'Pay-monthly sites for trades in Bristol, Bath, Somerset, Dorset, Glos, Wilts & South Wales. SSL & hosting — WebCodeCraft.',
  canonical: `${SITE_ORIGIN}/trades`
};

export function applyPageMeta({ title, description, canonical }) {
  const metaDesc = document.querySelector('meta[name="description"]');
  const metaTitle = document.querySelector('meta[name="title"]');
  const ogTitle = document.querySelector('meta[property="og:title"]');
  const ogDesc = document.querySelector('meta[property="og:description"]');
  const ogUrl = document.querySelector('meta[property="og:url"]');
  const twTitle = document.querySelector('meta[property="twitter:title"]');
  const twDesc = document.querySelector('meta[property="twitter:description"]');
  const twUrl = document.querySelector('meta[property="twitter:url"]');
  const linkCanonical = document.querySelector('link[rel="canonical"]');

  const prev = {
    title: document.title,
    description: metaDesc?.getAttribute('content') ?? '',
    metaTitle: metaTitle?.getAttribute('content') ?? '',
    ogTitle: ogTitle?.getAttribute('content') ?? '',
    ogDesc: ogDesc?.getAttribute('content') ?? '',
    ogUrl: ogUrl?.getAttribute('content') ?? '',
    twTitle: twTitle?.getAttribute('content') ?? '',
    twDesc: twDesc?.getAttribute('content') ?? '',
    twUrl: twUrl?.getAttribute('content') ?? '',
    canonical: linkCanonical?.getAttribute('href') ?? ''
  };

  document.title = title;
  metaDesc?.setAttribute('content', description);
  metaTitle?.setAttribute('content', title);
  ogTitle?.setAttribute('content', title);
  ogDesc?.setAttribute('content', description);
  twTitle?.setAttribute('content', title);
  twDesc?.setAttribute('content', description);
  if (canonical) {
    ogUrl?.setAttribute('content', canonical);
    twUrl?.setAttribute('content', canonical);
    linkCanonical?.setAttribute('href', canonical);
  }

  return function restorePageMeta() {
    document.title = prev.title;
    metaDesc?.setAttribute('content', prev.description);
    metaTitle?.setAttribute('content', prev.metaTitle);
    ogTitle?.setAttribute('content', prev.ogTitle);
    ogDesc?.setAttribute('content', prev.ogDesc);
    ogUrl?.setAttribute('content', prev.ogUrl);
    twTitle?.setAttribute('content', prev.twTitle);
    twDesc?.setAttribute('content', prev.twDesc);
    twUrl?.setAttribute('content', prev.twUrl);
    linkCanonical?.setAttribute('href', prev.canonical);
  };
}
